'use strict';

angular.module('theme').service('SsnNbService', function () {

	var invalid = {
		valid: false,
		sex: false
	};

	return function ssnService(value) {

		// Check for nulls and false lengths
		if (!value || value.length < 11) {
			return invalid;
		}

		// Remove dash and plus
		value = value.replace(' ', '').replace('-', '').replace('+', '');

		if (value.length !== 11) {
			return invalid;
		}

		// Calculate check number
		var _sum = function(value, factors){
			var sum = 0;
			for(var i = 0, l = factors.length; i < l; ++i){
				sum += parseInt(value.charAt(i),10) * factors[i];
			}
			return sum;
		};

		var checksum1 = 11 - (_sum(value, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
		if (checksum1 === 11) checksum1 = 0;
		var checksum2 = 11 - (_sum(value, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
		if (checksum2 === 11) checksum2 = 0;

		return {
			valid: checksum1 === parseInt(value.charAt(9), 10) && checksum2 === parseInt(value.charAt(10), 10),
			sex: ((parseInt(value.substr(8, 1), 10) % 2) === 0) ? 'female' : 'male',
			ssn: (parseInt(value.substr(2, 2), 10) < 13) && (parseInt(value.substr(0, 2), 10) < 32),
			formatted: value
		};

	};

});
